import { updateDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const UpdateSingleAgent = async (formData, AgentId) => {
  /**
   * input: null
   * output: agent document / collection
   * description: update agent / agent document
   */
  try {
    const AgentDocument = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "agents",
      AgentId
    );

    const data = HelperForMetaData({
      ...formData,
      bid: getLocalStorageItem("bid"),
    });
    const result = await updateDoc(AgentDocument, data);
    return result;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default UpdateSingleAgent;
